import Vue from 'vue';
import Vuex from 'vuex';
import VeeValidate from 'vee-validate';

Vue.use(Vuex);
Vue.use(VeeValidate);

import Consultancy from './modules/consultancy'
import Applicant from './modules/applicant'
export default new Vuex.Store({
    modules: {
        Consultancy,
        Applicant
    },
    strict: false
});


// WEBPACK FOOTER //
// ./src/store/index.js